export default "__VITE_ASSET__D6ZGu04h__"